<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>

        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
         <h3>Accounts for {{ campaignDescription.campaign_name }} </h3>


        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          
          <h3>Total : {{no_of_campaign_accounts}} </h3>


           </vs-col>
      </vs-row>
      <DataGrid :context="'MatchedAccountForCampaign'" 
        ref="MatchedAccountForCampaign"
        @sendSelectionToActualPage="sendSelectionToActualPage"
        :columnDefs="accountColumnDefs"
        :rowData="accountRecords"
        :dataSource="accountDataSource"
      >
      </DataGrid>



      <vs-row vs-w="12" class="mt-10">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> 
          

        </vs-col>


        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
         <h3>Contacts for {{ campaignDescription.campaign_name }}</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> 
          <h3>Total : {{no_of_campaign_contacts}} </h3>

        </vs-col>
      </vs-row>
      <DataGrid :context="'MatchedContactForCampaign'" 
        ref="MatchedContactForCampaign"
        :columnDefs="contactColumnDefs"
        :rowData="contactRecords"
        :dataSource="contactDataSource"
      >
      </DataGrid>
    </vx-card>
  </div>
</template>

<script>
var revanueValueFormatter = function(params) {
  if(params.data.revenue){

    if(params.data.currency_name != undefined){
      return params.data.currency_name + " " + params.data.revenue;
    }
  }
  // return '$' + params.value
};
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignsManagement from "@/store/campaign-management/moduleCampaignManagement.js";
// import ClientDataGrid from "@/components/aggrid/AggridClient.vue";
import axios from '@/axios.js'
import vSelect from "vue-select";
export default {
  data: () => ({
    no_of_campaign_accounts: 0,
    no_of_campaign_contacts: 0,
    allAccountRecords : null,
    companySDAccountComponentKey:0,
    abilities: null,
    accountColumnDefs: [
    ],
    campaignFieldsDataSource: {},
    campaignFieldsRecords: [],
    campaignsRecords: [],
    selected_accounts: [],
    contactColumnDefs: [],
    campaignName: null,
    campaignDescription: [],
    accountDataSource: {},
    campaignId: null,
    abilities: null,
    accountRecords: [],
    contactRecords: [],
    contactDataSource: {},
    campaign_account_none_core_field_columns: '',
    campaign_account_none_core_field_ids: '',
    campaign_contact_none_core_field_columns: '',
    campaign_contact_none_core_field_ids: '',
    enrich_none_core_number_type_ids : [],

  }),
  components: {
    "v-select": vSelect,
    DataGrid  },
  watch: {},
  methods: {
    getAllAccountSelectedCampaignColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getAllAccountSelectedCampaignColumns",
          self.$route.params.campaignId
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);



              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


              var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid
          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }


                let ele_with_t = 'acc' + index + '.' + ele.field;
                self.campaign_account_none_core_field_columns = self.campaign_account_none_core_field_columns + ',' + ele.id;
                self.campaign_account_none_core_field_ids = self.campaign_account_none_core_field_ids + ',' + ele_with_t;
                index += 1;

                }else{
                  ele.field = ele.identifier;
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.accountColumnDefs = selected_columns

          localStorage.setItem("campaign_account_none_core_field_columns", self.campaign_account_none_core_field_columns);
          localStorage.setItem("campaign_account_none_core_field_ids", self.campaign_account_none_core_field_ids);
          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);





            self.accountColumnDefs.push({ pinned: true, checkboxSelection: true, headerName: "#", width: 50 }
            );

        

        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllContactSelectedCampaignColumns() {
    var self = this;
    self.$store
      .dispatch(
        "campaignsManagement/getAllContactSelectedCampaignColumns",
        self.$route.params.campaignId
      )
      .then(res => {
            let selected_columns = JSON.parse(res.data);


            selected_columns = selected_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' && ele.identifier != 'contact_social_media_summary' && ele.identifier != 'grade' && ele.identifier != 'contact_status' && ele.identifier != 'contact_status_notes'
            });

            var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid

          
              ele.headerName = ele.name;

              if (ele.identifier == 'none_core_field') {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

                if (ele.type == 'number'){
                  self.enrich_none_core_number_type_ids.push(ele.field)
                }

                let ele_with_t = 'con' + index + '.' + ele.field;
                self.campaign_contact_none_core_field_columns = self.campaign_contact_none_core_field_columns + ',' + ele.id;
                self.campaign_contact_none_core_field_ids = self.campaign_contact_none_core_field_ids + ',' + ele_with_t;
                index += 1;

                }else{
                  ele.field = ele.identifier;
                }


                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.contactColumnDefs = selected_columns

          localStorage.setItem("campaign_contact_none_core_field_columns", self.campaign_contact_none_core_field_columns);
          localStorage.setItem("campaign_contact_none_core_field_ids", self.campaign_contact_none_core_field_ids);

          localStorage.setItem("enrich_none_core_number_type_ids", self.enrich_none_core_number_type_ids);

      

      

      })
      .catch(err => {
        console.log(err);
      });
  },
    sendSelectionToActualPage(items) {
      let selected_account_ids = [];
      items.forEach(element => {
        selected_account_ids.push(element.data.account_id);
      });


      console.log("Selected Account Ids" , selected_account_ids)

      this.selected_accounts = selected_account_ids;

     if (this.selected_accounts.length > 0) {
      this.$refs.MatchedContactForCampaign.gridApi.refreshServerSide({purge : true});
      this.getContactDataSource();
      } 

  
    },
    addFields() {
      this.$router.push({ path: `/fields/campaign-field/add` });
    },
    getAccountDataSource() {
      var self = this;

      this.accountDataSource = {
        getRows(params) {
          params.request.campaignId = self.$route.params.campaignId;
          params.request.campaignName = atob(self.$route.params.campaignName);
          params.request.campaign_account_none_core_field_columns = localStorage.getItem("campaign_account_none_core_field_columns");
          params.request.campaign_account_none_core_field_ids = localStorage.getItem("campaign_account_none_core_field_ids");
          params.request.enrich_none_core_number_type_ids = localStorage.getItem("enrich_none_core_number_type_ids");
          self.$store
            .dispatch(
              "accountsManagement/fetchAllMatchedAccountsListOfCampaign",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              

              if (response_data.length != 0) {
                self.$refs.MatchedAccountForCampaign.gridApi.hideOverlay();
                return params.success({ rowData: response_data })
              } else {
                self.$refs.MatchedAccountForCampaign.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }




            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    // getAllAccountDataSource() {
    //   var self = this;
    //   self.$vs.loading();

    //   let data = {}
    //   data.campaignId = self.$route.params.campaignId;
    //   data.campaignName = atob(self.$route.params.campaignName);
    //   self.$store
    //     .dispatch(
    //       "accountsManagement/fetchAllMatchedCampaignAccountsClientSide",
    //       data
    //     )
    //     .then(function(response) {
    //       let response_data = JSON.parse(response.data);


    //       self.allAccountRecords = response_data;

    //       self.$vs.loading.close();


    //       console.log("REsdddddddddsS" , response_data)
          

    //       // console.log("REssS" , response)
    //       // if (response_data.length != 0) {
    //       //   self.$refs.MatchedAccountForCampaign.gridApi.hideOverlay();
    //       //   return params.success({ rowData: response_data })
    //       // } else {
    //       //   self.$refs.MatchedAccountForCampaign.gridApi.showNoRowsOverlay();
    //       //   return params.success({ rowData: [] })
    //       // }
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },
    getContactDataSource() {


      var self = this;
      this.contactDataSource = {
        getRows(params) {
          params.request.campaignId = self.$route.params.campaignId;
          params.request.campaignName = atob(self.$route.params.campaignName);
          params.request.selected_accounts = self.selected_accounts;
          params.request.campaign_contact_none_core_field_columns = localStorage.getItem("campaign_contact_none_core_field_columns");
          params.request.campaign_contact_none_core_field_ids = localStorage.getItem("campaign_contact_none_core_field_ids");
          params.request.enrich_none_core_number_type_ids = localStorage.getItem("enrich_none_core_number_type_ids");



          self.$store
            .dispatch(
              "accountsManagement/fetchAllMatchedContactOfCampaign",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
          

                  console.log("Contact datasource " , response)
                  if (response_data.length != 0) {
                    self.$refs.MatchedContactForCampaign.gridApi.hideOverlay();
                    return params.success({ rowData: response_data })
                  } else {
                    self.$refs.MatchedContactForCampaign.gridApi.showNoRowsOverlay();
                    return params.success({ rowData: [] })
                  }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    getCampaignDescription() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaign",
          self.$route.params.campaignId
        )
        .then(res => {
          self.campaignDescription = res.data;
          console.log(self.campaignDescription);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getCampaignAccountsTotalRows() {
      

      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId

      axios
        .post(
          this.$base_url +
            '/api/accounts/get_campaign_accounts_total_rows',
          data
        )
        .then(response => {
          self.no_of_campaign_accounts = response.data

       


          
        
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCampaignContactsTotalRows() {
      

      let self = this
      let data = {}
      data.campaignId = this.$route.params.campaignId
      data.account_ids = []




      axios
        .post(
          this.$base_url +
            '/api/accounts/get_campaign_contacts_total_rows',
          data
        )
        .then(response => {
          self.no_of_campaign_contacts = response.data


          
        
        })
        .catch(error => {
          console.log(error)
        })
    },
    goBack: function() {
      this.$router
        .push("/accounts/matched_account_contact_list/")
        .catch(() => {});
    }
  },
  beforeMount() {

    this.getCampaignDescription();
    this.getAllAccountSelectedCampaignColumns();
    this.getAllContactSelectedCampaignColumns();


    this.getAccountDataSource();
    this.getContactDataSource();


   
  },
  destroyed() {
    // localStorage.removeItem('campaign_account_none_core_field_columns')
    // localStorage.removeItem('campaign_account_none_core_field_ids')
    // localStorage.removeItem('campaign_contact_none_core_field_columns')
    // localStorage.removeItem('campaign_contact_none_core_field_ids')
    // localStorage.removeItem('enrich_none_core_number_type_ids')

  
  },
  mounted() {

    this.getCampaignAccountsTotalRows();
    this.getCampaignContactsTotalRows();

   

  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleCampaignsManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignsManagement
      );
      moduleCampaignsManagement.isRegistered = true;
    }
    this.campaignId = this.$route.params.campaignId;
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
